import { render } from "./WantedInvoiceEmail.vue?vue&type=template&id=383fa321&ts=true"
import script from "./WantedInvoiceEmail.vue?vue&type=script&lang=ts"
export * from "./WantedInvoiceEmail.vue?vue&type=script&lang=ts"

import "./WantedInvoiceEmail.vue?vue&type=style&index=0&id=383fa321&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__